import { customizeConfig } from '@store/config'
import { InitialConfig } from '@loctypes/initial-config'

export const applyCustomizeConfig = (dotProps: InitialConfig['customizing']) => {
  if (dotProps) {
    customizeConfig(dotProps)
  }
}
